export const DeleteNodesZone = () => {
  return (
    <div className="left-sidebar__remove-node">
      <div className="delete-node">
        <i className="ri-delete-bin-5-line ri-2x"></i>
      </div>
    </div>
  );
};
